import { Box, Eye, Grid3x3, Minus, Plus, RotateCcw } from "lucide-react";

const Btn = ({ children, onClick, active, id, label }) => (
  <button
    type="button"
    aria-label={label}
    title={label}
    data-testid={id}
    onClick={onClick}
    className={`h-8 px-2.5 rounded-lg text-[11px] font-medium flex items-center gap-1 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff5a00] ${
      active ? "bg-[#ff5a00] text-white" : "text-zinc-300 hover:text-white hover:bg-white/10"
    }`}
  >
    {children}
  </button>
);

export const ViewToolbar = ({ viewer, view, setView, wireframe, setWireframe, bg, setBg }) => (
  <>
    <div className="absolute top-3 right-3 z-10 flex flex-wrap gap-1 p-1 rounded-xl bg-black/60 backdrop-blur-xl border border-white/10" data-testid="view-toolbar">
      {["perspective", "front", "side", "top"].map((v) => (
        <Btn key={v} id={`view-${v}-btn`} label={`${v} view`} active={view === v} onClick={() => { setView(v); viewer.current?.setView(v); }}>
          {v === "perspective" ? <Eye size={12} /> : null}
          <span className="capitalize">{v === "perspective" ? "Persp" : v}</span>
        </Btn>
      ))}
    </div>
    <div className="absolute bottom-3 right-3 left-3 sm:left-auto z-10 flex flex-wrap justify-center sm:justify-start gap-1 p-1 rounded-xl bg-black/60 backdrop-blur-xl border border-white/10">
      <Btn id="render-solid-btn" label="Solid rendering" active={!wireframe} onClick={() => setWireframe(false)}><Box size={13} /> Solid</Btn>
      <Btn id="render-wireframe-btn" label="Wireframe rendering" active={wireframe} onClick={() => setWireframe(true)}><Grid3x3 size={13} /> Wire</Btn>
      <span className="w-px bg-white/10 mx-1" />
      <Btn id="zoom-in-btn" label="Zoom in" onClick={() => viewer.current?.zoom(0.8)}><Plus size={13} /></Btn>
      <Btn id="zoom-out-btn" label="Zoom out" onClick={() => viewer.current?.zoom(1.25)}><Minus size={13} /></Btn>
      <Btn id="reset-camera-btn" label="Reset camera" onClick={() => { setView("perspective"); viewer.current?.reset(); }}><RotateCcw size={13} /> Reset</Btn>
      <span className="w-px bg-white/10 mx-1" />
      <label className="h-8 px-2 flex items-center gap-1.5 text-[11px] text-zinc-300 cursor-pointer" title="Viewport background">
        BG
        <input type="color" value={bg} onChange={(e) => setBg(e.target.value)} data-testid="viewport-bg-input" aria-label="Viewport background color" className="h-5 w-6 rounded bg-transparent border-0 cursor-pointer" />
      </label>
    </div>
  </>
);
